import { c as _c } from "react/compiler-runtime";
import { AddIcon } from '@systemeio/ui/icons';
import { Modal } from '@systemeio/ui';
import { triggerItems } from 'modules/automation-rules/triggers/constants/trigger-items';
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useAllowedTriggers } from '../hooks/use-allowed-triggers';
interface AddTriggerModalProps {
  isReady: boolean;
  onAddTrigger: (trigger: AutomationRuleTriggersEnum) => void;
  allowedTriggers?: AutomationRuleTriggersEnum[];
}
const AddTriggerModal = t0 => {
  const $ = _c(32);
  const {
    onAddTrigger,
    isReady,
    allowedTriggers
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const finalAllowedTriggers = useAllowedTriggers(allowedTriggers);
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== finalAllowedTriggers || $[1] !== isReady || $[2] !== onAddTrigger || $[3] !== opened || $[4] !== t) {
    let t7;
    if ($[12] !== finalAllowedTriggers) {
      t7 = trigger => finalAllowedTriggers.includes(trigger.slug);
      $[12] = finalAllowedTriggers;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const filteredTriggers = triggerItems.filter(t7);
    t6 = filteredTriggers.length !== 0 && <button disabled={!isReady} onClick={() => setOpened(true)} className={`group flex self-center rounded-full outline-hidden ${!isReady && "pointer-events-none"}`}><AddIcon className={`${!isReady && "fill-fill-primary/70 animate-pulse"} main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary fill-fill-primary h-[30px] w-[30px]`} /></button>;
    T0 = Modal;
    if ($[14] !== t) {
      t3 = t("dashboard.automation_rule.edit.add_trigger");
      $[14] = t;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t4 = opened;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = () => setOpened(false);
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t1 = "flex flex-col gap-5 px-10";
    let t8;
    if ($[17] !== onAddTrigger || $[18] !== t) {
      t8 = (trigger_0, idx) => <button onClick={() => {
        onAddTrigger(trigger_0.slug);
        setOpened(false);
      }} key={idx} className={`group flex w-full gap-3 text-left outline-hidden ${idx !== 0 && "border-text-secondary/30 border-t pt-5"}`}><div className="[&>svg]:main-transition-colors [&>svg]:group-hover:fill-brand-primary [&>svg]:group-focus-visible:fill-brand-primary [&>svg]:group-hover:stroke-brand-primary [&>svg]:group-focus-visible:stroke-brand-primary [&>svg]:h-[40x] [&>svg]:w-[40px] w-[40px]">{trigger_0.icon}</div><div className="flex flex-col gap-1"><span className="text-text-primary text-[15px] font-bold">{t(trigger_0.title)}</span><span>{t(trigger_0.description)}</span></div></button>;
      $[17] = onAddTrigger;
      $[18] = t;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t2 = filteredTriggers.map(t8);
    $[0] = finalAllowedTriggers;
    $[1] = isReady;
    $[2] = onAddTrigger;
    $[3] = opened;
    $[4] = t;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[20] !== t1 || $[21] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== T0 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t7) {
    t8 = <T0 title={t3} opened={t4} onClose={t5}>{t7}</T0>;
    $[23] = T0;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t6 || $[30] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[29] = t6;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
export default AddTriggerModal;